<script lang="ts">
import { computed } from 'vue';

export interface PhxsgIconProps {
  id: string;
  size?: string;
  title?: string;
  iconsPath?: string;
  bidirectional?: boolean;
}
</script>

<script setup lang="ts">
const {
  id,
  size = 'md',
  title = null,
  iconsPath = window.Phoenix?.iconsPath,
  bidirectional = false,
} = defineProps<PhxsgIconProps>();

const url = computed(() => `${iconsPath}#${id}`);
const uniqueId = computed(() => `id${Math.random().toString(36).substring(2, 9)}`);
</script>

<template>
  <svg
    :class="[
      `phxsg-icon phxsg-icon--${id}`,
      {
        [`phxsg-icon--${size}`]: size,
        'phxsg-icon--bidirectional': bidirectional,
      },
    ]"
    :aria-hidden="!title"
    focusable="false"
    :aria-labelledby="title ? uniqueId : undefined"
    role="img"
  >
    <title v-if="title" :id="uniqueId">{{ title }}</title>
    <use :xlink:href="url" />
  </svg>
</template>

<style src="./icon.css" />
